import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  textToolbar: {
    '& button': {
      color: 'black'
    }
  }
});
